export type SocialPlatform = 'facebook' | 'youtube' | 'instagram' | 'tiktok';
export type ConnectionStatus = 'conectado' | 'pendiente' | 'error';

export interface SocialAccount {
  id: SocialPlatform;
  name: string;
  icon: string;
  color: string;
  bgColor: string;
  label: string;
  status: ConnectionStatus;
  accountName: string;
  accountId: string;
  pageUrl: string;
  connectedAt: string | null;
  followers: number;
  lastSync: string | null;
  errorMessage: string | null;
}

export const socialAccounts: SocialAccount[] = [
  {
    id: 'facebook',
    name: 'Facebook',
    icon: 'ri-facebook-fill',
    color: 'text-[#1877F2]',
    bgColor: 'bg-[#1877F2]',
    label: 'Página de Facebook',
    status: 'conectado',
    accountName: 'Radio RFW Oficial',
    accountId: 'PF-482917364829',
    pageUrl: 'https://facebook.com/RadioFrecuenciaWeb',
    connectedAt: '2026-05-15T14:30:00',
    followers: 48720,
    lastSync: '2026-06-19T10:00:00',
    errorMessage: null,
  },
  {
    id: 'youtube',
    name: 'YouTube',
    icon: 'ri-youtube-fill',
    color: 'text-[#FF0000]',
    bgColor: 'bg-[#FF0000]',
    label: 'Canal de YouTube',
    status: 'conectado',
    accountName: 'RadioFrecuenciaWeb TV',
    accountId: 'UC-938475612034',
    pageUrl: 'https://youtube.com/@RadioFrecuenciaWebTV',
    connectedAt: '2026-04-20T09:00:00',
    followers: 32400,
    lastSync: '2026-06-19T09:45:00',
    errorMessage: null,
  },
  {
    id: 'instagram',
    name: 'Instagram',
    icon: 'ri-instagram-fill',
    color: 'text-[#E4405F]',
    bgColor: 'bg-[#E4405F]',
    label: 'Cuenta de Instagram',
    status: 'pendiente',
    accountName: '',
    accountId: '',
    pageUrl: '',
    connectedAt: null,
    followers: 0,
    lastSync: null,
    errorMessage: null,
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    icon: 'ri-tiktok-fill',
    color: 'text-background-50',
    bgColor: 'bg-[#000000]',
    label: 'Cuenta de TikTok',
    status: 'error',
    accountName: '@radiofrecuenciaweb',
    accountId: 'TK-729384651',
    pageUrl: 'https://tiktok.com/@radiofrecuenciaweb',
    connectedAt: '2026-06-01T11:00:00',
    followers: 18900,
    lastSync: '2026-06-16T08:00:00',
    errorMessage: 'Token de acceso expirado. La sesión no pudo renovarse automáticamente.',
  },
];

export const statusMeta: Record<ConnectionStatus, { label: string; dot: string; text: string; bg: string }> = {
  conectado: { label: 'Conectado', dot: 'bg-emerald-500', text: 'text-emerald-600', bg: 'bg-emerald-50' },
  pendiente: { label: 'Pendiente', dot: 'bg-amber-400', text: 'text-amber-600', bg: 'bg-amber-50' },
  error: { label: 'Error', dot: 'bg-rose-500', text: 'text-rose-600', bg: 'bg-rose-50' },
};